class GenericPaging {
    constructor(_guid) {
        if (_guid !== undefined) {
            this.sectionGuid = _guid;
        } else {
            this.sectionGuid = null;
        }
    }

    sectionGuid = null;

    perPage = null;
    pagedItemCount = 0;
    pageNo = 1;

    parentElement = null;
    pagedItems = null;
    $paginationTarget = null;

    me = this;

    InitGenericPaging(_resultsPerPage, _parentElementID, _pagedItemSelector) {
        this.sectionGuidWithUnderScore = (this.sectionGuid === null) ? '' : '_' + this.sectionGuid;

        this.perPage = _resultsPerPage;
        this.parentElement = document.querySelector(_parentElementID + this.sectionGuidWithUnderScore);
        this.pagedItems = this.parentElement.querySelectorAll(_pagedItemSelector);
        this.pagedItemCount = this.pagedItems.length;
        this.$paginationTarget = $('#pagination_search' + this.sectionGuidWithUnderScore);

        this.$paginationTarget.pagination({
            items: this.pagedItemCount,
            itemsOnPage: this.perPage,
            cssStyle: 'light-theme',
            onPageClick: function (_pageNo, event) {
                event.preventDefault();
                this.ChangePage(_pageNo);
            }.bind(this),
            onInit: function () {
                //console.log('Init paging %o', this);
                var resultCount = 0;
                if (this.pagedItems !== null) {
                    resultCount = this.pagedItemCount;
                }
                this.DoPagination(resultCount, this.pageNo);
            }.bind(this)
        });
        this.ChangePage(1);
    }

    ChangePage(toPage) {
        var toPage = (toPage - 1); // 0 based
        var startPage = (toPage > 0) ? (toPage * this.perPage) : 0;
        var endPage = (toPage > 0) ? (startPage + this.perPage) : this.perPage;

        //console.log(startPage + " - " + endPage + " - " + this.pagedItemCount);
        for (let i = 0; i < this.pagedItemCount; i++) {
            if (i >= startPage && i < endPage) {
                this.pagedItems[i].classList.remove('hidden');
            } else {
                this.pagedItems[i].classList.add('hidden');
            }
        }
    }

    DoPagination(resultCount, currentPage) {
        if (resultCount !== null && resultCount > this.perPage) {
            this.$paginationTarget.pagination('destroy');
            this.$paginationTarget.pagination('updateItems', resultCount);
            this.$paginationTarget.pagination('drawPage', currentPage);
            this.$paginationTarget.show();
        } else {
            this.$paginationTarget.hide();
        }
    }
}